<mat-accordion>
  @if (descriptions.length>0) {
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title> Product Description </mat-panel-title>
    </mat-expansion-panel-header>
    <ul>
      @for (description of descriptions; track $index) {
      <li>
        <p>{{description}}</p>
      </li>
      }
    </ul>
  </mat-expansion-panel>
  }
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Free 30-Day Returns </mat-panel-title>
    </mat-expansion-panel-header>
    <ul>
      <li>
        Free returns all the time when you choose store credit. Prefer a Refund?
        You can send it back to your original payment method for a $7.95
        processing fee. Final Sale items cannot be returned or exchanged.
      </li>
      <li>
        You can find additional information about our
        <a
          routerLink="/return-and-exchange-policy"
          aria-label="Return & Exchange Policy"
          >Return & Exchange Policy</a
        >
        .
      </li>
    </ul>
  </mat-expansion-panel>
</mat-accordion>
